module.exports = {
  //DEFAULT_PROFILE: 'default',
  // WEBAPP_EXH_PROFILE: 'webapp-exh',
  // WEBAPP_EVT_PROFILE: 'webapp-evt',
  // WEBAPP_SPK_PROFILE: 'webapp-spk'
  Présentiel: 'presentiel',
  Online: 'online'
};